// extracted by mini-css-extract-plugin
module.exports = {"atm_gq_idpfg4":"atm_gq_idpfg4"};